import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import Select from '../../../../../Components/Select/Select';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import type { ImpersonationState } from './ImpersonationsTable';
import { useStyles } from './ImpersonationsTable.styles';

interface Props {
  value: ImpersonationState;
  onChange: (value: ImpersonationState) => void;
}

export const ImpersonationListFilter: FC<Props> = ({ value, onChange }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const all = { value: 'all', label: formatMessage({ id: 'admin.impersonations.filter.all.impersonations' }) };
  const active = { value: 'active', label: formatMessage({ id: 'utils.filters.status.active' }) };
  const expired = { value: 'expired', label: formatMessage({ id: 'admin.impersonations.filter.expired' }) };
  const pending = { value: 'pending', label: formatMessage({ id: 'dashboard.impersonation.pending' }) };
  const options = [all, active, expired, pending];
  const selected = options.find((option) => option.value === value);
  return (
    <Select
      className={classes.statusFilter}
      selectProps={{
        options,
        value: selected,
        isClearable: false,
        isSearchable: false,
        onChange: (option) => onChange(String((option as SelectOption).value) as ImpersonationState),
      }}
    />
  );
};
